<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" label-width="130px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="areaId" label="区域">
              {{ formData.areaName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="gridId" label="网格">
              {{ formData.gridName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inspectionDate" label="检查日期">
              {{ formData.inspectionDate }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="finalScore" label="最终结果">
              {{ finalScoreMap.get(formData.finalScore) }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="evaluation" label="检查评价">
              {{ formData.evaluation }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="itemList" label="检查项">
              <el-table size="mini" stripe border :data="formData.itemList">
                <el-table-column min-width="120" label="检查项" prop="itemName"></el-table-column>
                <el-table-column min-width="120" label="检查结果" prop="result">
                  <template v-slot="{ row }">
                    {{ finalScoreMap.get(row.result) }}
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="检查备注" prop="resultMsg">
                </el-table-column>
                <el-table-column min-width="120" label="检查图片" prop="resultImg">
                  <template v-slot="{ row }">
                    <el-image :src="row.resultImg" fit="fill" :preview-src-list="[row.resultImg]" />
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
import { finalScore } from '@/utils/dict'
export default {
  name: 'CheckResultDetail',
  components: {
  },
  data() {
    return {
      finalScoreMap: finalScore,
      formData: {
        areaId: '', // 区域id
        gridId: '', // 网格id
        inspectionDate: '', // 检查日期
        finalScore: '', // 最终结果 2合格 1基本合格 0不合格
        evaluation: '', // 检查评价
        itemList: [] // 检查项列表
      }
    }
  },
  created() {
    if (this.recordId) {
      this.loadData()
    }
  },
  computed: {
    recordId() {
      return this.$route.query.recordId
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaSanitationResultByRecordId, { recordId: this.recordId }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
